export default {
    SET_USER_BANNER: 'SET_USER_BANNER',
    USER_BANNER: 'USER_BANNER',
    BANNER_TEXT: 'BANNER_TEXT',
    IMAGE_FILE_PATH: 'IMAGE_FILE_PATH',
    IMAGE_OVERLAY: 'IMAGE_OVERLAY',
    TEXT_COLOR: 'TEXT_COLOR',
    BANNER_LINK: 'BANNER_LINK',
    BANNER_HEIGHT:'BANNER_HEIGHT'
}


// WEBPACK FOOTER //
// ./constants/banner.js